import React from 'react';
import { Form, Message } from 'semantic-ui-react';

export const imageTokenFields = [
  ['text_input_price', '文本输入'],
  ['cached_text_input_price', '缓存文本输入'],
  ['image_input_price', '图片输入'],
  ['cached_image_input_price', '缓存图片输入'],
  ['image_output_price', '图片输出'],
];

export function buildImageTokenPricing(model) {
  if (model.time_pricing || model.context_rules?.length || model.conditional_rules?.length)
    throw new Error('图片 Token 定价不能叠加峰谷、上下文或条件规则');
  const prices = {};
  imageTokenFields.forEach(([key, label]) => {
    const point = model.image_token_pricing?.[key];
    if (point?.cny != null || point?.usd == null || !/^\d+(\.\d+)?$/.test(String(point.usd)))
      throw new Error(`${label}必须填写非负美元单价`);
    prices[key] = { usd: point.usd };
  });
  return prices;
}

export function ImageTokenPricingEditor({ model, onChange }) {
  return (
    <>
      <Message info content='按实际图片 Token 明细结算，单位为美元/百万 Token，所有渠道统一定价。' />
      {imageTokenFields.map(([key, label]) => (
        <Form.Input
          key={key}
          label={`${label}（USD / 1M tokens）`}
          type='number'
          min='0'
          step='any'
          value={model.image_token_pricing?.[key]?.usd ?? ''}
          onChange={(_, { value }) => onChange({
            ...model,
            uniform_pricing: true,
            image_token_pricing: {
              ...model.image_token_pricing,
              [key]: { usd: value },
            },
          })}
        />
      ))}
    </>
  );
}

export default function ImageTokenPricingDetails({ pricing }) {
  return (
    <div>
      {imageTokenFields.map(([key, label]) => (
        <div key={key}>
          {label}: {pricing.image_token_pricing?.[key]?.usd != null
            ? `$${pricing.image_token_pricing[key].usd} / 1M tokens`
            : '未配置'}
        </div>
      ))}
      <small>按实际用量结算；缓存从输入总量中扣除，不重复收费。所有渠道统一定价。</small>
    </div>
  );
}
